import { createReducer } from 'reduxsauce';
import { Types } from './actions';

const INITIAL_STATE = {
  loading: false,
  bannerData: null,
  latest: null,
  pageForLatest: 1,
  trending: null,
  reviews: null
};

// *************************** Fetch Banner ****************************
const fetchHomeBannerStart = (state = INITIAL_STATE, action) => {
  return { ...state, loading: true };
};

const fetchHomeBannerSuccess = (state = INITIAL_STATE, action) => {
  return { ...state, bannerData: action.bannerData, loading: false };
};

const fetchHomeBannerFailure = (state = INITIAL_STATE, action) => {
  return { ...state, loading: false };
};
// _____________________________________________________________________

// ************************ Fetch Trending ************************
const fetchTrendingStart = (state = INITIAL_STATE, action) => {
  return { ...state, loading: true };
};

const fetchTrendingSuccess = (state = INITIAL_STATE, action) => {
  return { ...state, trending: action.trending, loading: false };
};

const fetchTrendingFailure = (state = INITIAL_STATE, action) => {
  return { ...state, loading: false };
};
// _____________________________________________________________________

// ************************* Fetch Latest *************************
const fetchLatestStart = (state = INITIAL_STATE, action) => {
  return { ...state, loading: true };
};

const fetchLatestSuccess = (state = INITIAL_STATE, action) => {
  // console.log('action: ', action);
  let latest = [];
  if (state.latest === null && action.latest.pageNumber === 1) {
    latest = action.latest.latest;
  } else if (action.latest.pageNumber === 1) {
    latest = [...state.latest];
  } else {
    latest = [...state.latest, ...action.latest.latest];
  }

  return {
    ...state,
    latest: latest,
    pageForLatest: state.pageForLatest + 1,
    loading: false
  };
};

const fetchLatestFailure = (state = INITIAL_STATE, action) => {
  return { ...state, loading: false };
};
// _____________________________________________________________________

// ************************** Fetch Reviews ***************************
const fetchReviewsStart = (state = INITIAL_STATE, action) => {
  return { ...state, loading: true };
};

const fetchReviewsSuccess = (state = INITIAL_STATE, action) => {
  return { ...state, reviews: action.reviews, loading: false };
};

const fetchReviewsFailure = (state = INITIAL_STATE, action) => {
  return { ...state, loading: false };
};
// _____________________________________________________________________

// Define Handlers
const HANDLERS = {
  [Types.FETCH_HOME_BANNER_START]: fetchHomeBannerStart,
  [Types.FETCH_HOME_BANNER_FAILURE]: fetchHomeBannerFailure,
  [Types.FETCH_HOME_BANNER_SUCCESS]: fetchHomeBannerSuccess,

  [Types.FETCH_TRENDING_START]: fetchTrendingStart,
  [Types.FETCH_TRENDING_FAILURE]: fetchTrendingFailure,
  [Types.FETCH_TRENDING_SUCCESS]: fetchTrendingSuccess,

  [Types.FETCH_LATEST_START]: fetchLatestStart,
  [Types.FETCH_LATEST_FAILURE]: fetchLatestFailure,
  [Types.FETCH_LATEST_SUCCESS]: fetchLatestSuccess,

  [Types.FETCH_REVIEWS_START]: fetchReviewsStart,
  [Types.FETCH_REVIEWS_FAILURE]: fetchReviewsFailure,
  [Types.FETCH_REVIEWS_SUCCESS]: fetchReviewsSuccess
};

// Create and Export Reducer
export const homeReducer = createReducer(INITIAL_STATE, HANDLERS);
